import { GLServiceBase, ServiceRoute } from "commonui";
import { IReportManager } from "./interface";
import {
	MaterialTitleRequestModel,
	MaterialTitleResponseModel,
	WordCoundReportResponseModel,
	WordCountReportRequestModel
} from "./model";

class ReportServiceClass extends GLServiceBase<any, any> implements IReportManager {
	serviceRoute: ServiceRoute = { prefix: "content/v1/vcsReports" };

	getMaterialTitle(materialTitleRequestModel: MaterialTitleRequestModel): Promise<MaterialTitleResponseModel[]> {
		return this.get("materialTitle", materialTitleRequestModel);
	}

	// getWordCountReport(wordCountRequestModel: WordCountReportRequestModel): Promise<WordCoundReportResponseModel[]> {
	// 	return this.get("dummyWordCountReport", wordCountRequestModel);
	// }

	getWordCountReport(wordCountRequestModel: WordCountReportRequestModel): Promise<WordCoundReportResponseModel[]> {
		return this.get("wordCountReport", wordCountRequestModel);
	}

	getTextChangeAnalysisReport(data): Promise<any> {
		return this.create("textchangeanalysis", data);
	}
}

export const ReportManagerService = () => new ReportServiceClass();
